import {FC, useContext, useEffect} from 'react';
import {useRecoilStateLoadable} from 'recoil';

import Layout from '../../components/Layout';
import Fallback from '../../ui/fallback/Fallback';
import HasNoApiAccess from '../../ui/has-no-api-access/HasNoApiAccess';

import {companiesForMapQuery, companiesQuery} from '../../store/company/selectors';
import {deviceTypesDictQuery} from '../../store/deviceTypes/selectors';

import {AuthContext} from '../../providers/AuthContextProvider';
import {EventBusContext} from '../../providers/EventBus';

const Root: FC = () => {
  const [{state: companiesState, contents: companiesContents}, setCompanies] = useRecoilStateLoadable(companiesQuery);
  const [{state: companiesForMapState, contents: companiesForMapContents}, setCompaniesForMap] =
    useRecoilStateLoadable(companiesForMapQuery);
  const [{state: deviceTypesState, contents: deviceTypesContents}, setDeviceTypes] =
    useRecoilStateLoadable(deviceTypesDictQuery);
  const {bus} = useContext(EventBusContext);
  const {apiAccess, loading} = useContext(AuthContext);

  useEffect(() => {
    function handleState<T>(state: string, setStateFn: (data: T) => void, data: T, errorToastId: string) {
      if (state === 'hasValue') {
        setStateFn(data);
      } else if (apiAccess?.hasAccess && state === 'hasError') {
        bus?.emit('error', [data, {toastId: errorToastId}]);
      }
    }

    handleState(companiesState, setCompanies, companiesContents, 'companies');
    handleState(deviceTypesState, setDeviceTypes, deviceTypesContents, 'deviceTypes');
    handleState(companiesForMapState, setCompaniesForMap, companiesForMapContents, 'companies');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companiesState, deviceTypesState, companiesForMapState, apiAccess?.hasAccess]);

  if (!apiAccess?.loading && !apiAccess?.hasAccess) return <HasNoApiAccess />;

  if (loading || companiesForMapState === 'loading') return <Fallback />;

  return <Layout />;
};

export default Root;
